import WidgetLayoutContainer from 'consumer-page-widgets/WidgetUtils/WidgetLayoutContainer';

export function wrapWithWidgetContainer(content: React.ReactNode) {
  return <WidgetLayoutContainer>{content}</WidgetLayoutContainer>;
}
